import { Box, TextField, Typography, Divider, Grid, MenuItem, Button, FormControl, InputLabel, Snackbar, Select, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Alert } from "@mui/material";
import { useState } from "react";
import { categories } from "../../../data/category.js";
import "../../../styles/admin.css/products-css/add-product.css";
import { Add, Delete } from "@mui/icons-material";
import {
    useAddOwnedProductMutation,
    useAddConsignedProductMutation,
    useAddOtherProductMutation,
    useAddCompanyMutation,
    useGetAllCompaniesQuery,
    useDeleteCompanyMutation
} from "../../../redux/slices/admin/product/newProduct.js";

export default function AddProduct() {
    const [productType, setProductType] = useState("Digər məhsul");
    const [formData, setFormData] = useState({
        productName: "",
        category: "",
        subCategory: "",
        salePrice: "",
        cost: "",
        quantity: "",
        fuelType: "",
        code: "",
        color: "",
        company: "",
        literForOneBidon: "",
    });

    const fuelTypes = ["Benzin", "Dizel", "Hybrid", "Benzin / Dizel"];
    const [openPopup, setOpenPopup] = useState(false);
    const [deletePopup, setDeletePopup] = useState({ open: false, id: null, name: "" });
    const [newCompany, setNewCompany] = useState("");
    const [showRengInput, setShowRengInput] = useState(false);
    const [reng, setReng] = useState("");

    const [addCompany] = useAddCompanyMutation();
    const [addOwnedProduct] = useAddOwnedProductMutation();
    const [addConsignedProduct] = useAddConsignedProductMutation();
    const [addOtherProduct] = useAddOtherProductMutation();
    const [deleteCompany] = useDeleteCompanyMutation();

    const { data: companiesData = [], isLoading, refetch } = useGetAllCompaniesQuery();
    const companiesArray = Array.isArray(companiesData.data) ? companiesData.data : [];

    const isOilSubSelected = productType === "Yağlar";

    const selectedSubObject = getSubCategories().find(sc => sc.id === Number(formData.subCategory));
    const isBrakeFluidSelected = productType === "Filter" && selectedSubObject?.name === "Əyləc mayesi";

    const [toast, setToast] = useState({ open: false, severity: "success", message: "" });

    const handleProductNameInput = (value) => {
        if (value.length > 50) return;
        setFormData({ ...formData, productName: value });
    };

    const handleCodeInput = (value) => {
        setFormData({ ...formData, code: value });
    };

    const handleRemoveCompany = async (id) => {
        if (!id) return;
        try {
            await deleteCompany(id).unwrap();
            setToast({ open: true, severity: "success", message: "Şirkət silindi!" });
            refetch();
        } catch (err) {
            setToast({ open: true, severity: "error", message: "Şirkət silinə bilmədi!" });
        }
    };

    const handleDecimalNumberInput = (field, value) => {
        if (value === "") {
            setFormData({ ...formData, [field]: "" });
            return;
        }
        if (!/^\d*\.?\d*$/.test(value)) return;
        setFormData({ ...formData, [field]: value });
    };

    const handleNumberInput = (field, value) => {
        if (value === "") {
            setFormData({ ...formData, [field]: "" });
            return;
        }
        if (!/^\d+$/.test(value)) return;
        if (value.length > 1 && value.startsWith("0")) return;
        setFormData({ ...formData, [field]: value });
    };

    const isFormValid = () => {
        if (productType === "Yağlar") {
            const selectedSub = getSubCategories().find(sc => sc.id === formData.subCategory);
            return formData.productName.trim() !== "" &&
                formData.salePrice !== "" &&
                formData.quantity !== "" &&
                formData.literForOneBidon !== "" &&
                formData.cost !== "" &&
                formData.company !== "" &&
                formData.code.trim() !== "" &&
                formData.fuelType !== "" &&
                formData.subCategory !== "" &&
                (!showRengInput || (selectedSub?.name === "Antifriz" && reng.trim() !== ""));
        }

        if (productType === "Filter") {
            const basicValidation = formData.productName.trim() !== "" &&
                formData.salePrice !== "" &&
                formData.quantity !== "" &&
                formData.subCategory !== "" &&
                formData.cost !== "";

            if (isBrakeFluidSelected) {

                return basicValidation && formData.literForOneBidon !== "";
            } else {

                return basicValidation && formData.fuelType !== "" && formData.code !== "";
            }
        }

        return formData.productName.trim() !== "" &&
            formData.salePrice !== "" &&
            formData.cost !== "" &&
            formData.quantity !== "" &&
            formData.category !== "" &&
            formData.subCategory !== "";
    };

    const handleAddCompany = async () => {
        const name = newCompany.trim();
        if (!name) return;
        try {
            await addCompany(name).unwrap();
            setNewCompany("");
            setOpenPopup(false);
            setToast({ open: true, severity: "success", message: "Şirkət əlavə olundu!" });
            refetch();
        } catch (err) {
            setToast({ open: true, severity: "error", message: "Şirkət əlavə edilə bilmədi!" });
        }
    };

    const handleSubmit = async () => {
        setToast({ ...toast, open: false });
        try {
            let payload = {};
            let subId = Number(formData.subCategory);

            if (productType === "Filter") {
                const selectedSub = getSubCategories().find(sc => sc.id === subId);

                let categoryId = 3;

                payload = {
                    name: String(formData.productName),
                    categoryId: categoryId,
                    subcategoryId: subId,
                    sellPrice: Number(formData.salePrice || 0),
                    costPrice: Number(formData.cost || 0),
                    quantity: Number(formData.quantity || 0),

                    ...(isBrakeFluidSelected
                        ? { literForOneBidon: Number(formData.literForOneBidon || 0) }
                        : { fuelType: String(formData.fuelType || "Benzin"), code: String(formData.code || "") }
                    )
                };
                if (selectedSub?.name === "Əyləc mayesi") {
                    await addConsignedProduct(payload).unwrap();
                }
                else {
                    await addOwnedProduct(payload).unwrap();
                }
            }

            else if (productType === "Yağlar") {
                payload = {
                    name: String(formData.productName),
                    categoryId: 1, // "Yaxıt və maye məhsulları"
                    companyId: Number(formData.company),
                    literForOneBidon: Number(formData.literForOneBidon || 0),
                    sellPrice: Number(formData.salePrice || 0),
                    quantity: Number(formData.quantity || 0),
                    fuelType: String(formData.fuelType || "Benzin"),
                    code: String(formData.code || ""),
                    costPrice: Number(formData.cost || 0),
                    subcategoryId: subId,
                    ...(showRengInput && reng.trim() !== "" ? { color: reng.trim() } : {})
                };
                console.log(payload)
                await addConsignedProduct(payload).unwrap();
            }

            else {
                payload = {
                    name: String(formData.productName),
                    categoryId: Number(categories.find(c => c.category === formData.category)?.id),
                    subcategoryId: subId,
                    sellPrice: Number(formData.salePrice || 0),
                    costPrice: Number(formData.cost || 0),
                    quantity: Number(formData.quantity || 0)
                };
                console.log(payload)
                await addOtherProduct(payload).unwrap();
            }

            setToast({ open: true, severity: "success", message: "Məhsul bazaya əlavə edildi!" });
            setFormData({
                productName: "", salePrice: "", cost: "", quantity: "",
                fuelType: "", subCategory: "", code: "", company: "", literForOneBidon: ""
            });
            setReng("");
            setShowRengInput(false);

        } catch (err) {
            setToast({
                open: true,
                severity: "error",
                message: err.data?.message || "Məlumat göndərilmədi"
            });
        }
    };

    function getSubCategories() {
        if (productType === "Filter") {
            const spareParts = categories.find(c => c.id === 3);
            const sparePartsFilters = spareParts?.subCategories.filter(sc =>
                sc.name === "Yağ filtiri" || sc.name === "Hava filtiri" || sc.name === "Əyləc mayesi"
            ) || [];

            const autoParts = categories.find(c => c.id === 3);
            const autoPartsFilters = autoParts?.subCategories.filter(sc =>
                sc.name === "Benzin filtiri" || sc.name === "Salon filtiri" || sc.name === "Transmissiya filtiri"
            ) || [];

            return [...sparePartsFilters, ...autoPartsFilters];
        }
        if (productType === "Yağlar") {
            const oilCategory = categories.find(c => c.id === 1);
            return oilCategory?.subCategories.filter(sc =>
                sc.name === "Antifriz" || sc.name === "Transmissiya yağı" || sc.name === "Motor yağı"
            ) || [];
        }

        if (formData.category === "") return [];
        const cat = categories.find(c => c.category === formData.category);
        if (!cat) return [];

        let subCats = cat.subCategories || [];
        if (cat.id === 1) {
            subCats = subCats.filter(sc => !["Motor yağı", "Transmissiya yağı", "Antifriz"].includes(sc.name));
        } else if (cat.id === 3) {
            subCats = subCats.filter(sc => !["Yağ filtiri", "Hava filtiri", "Benzin filtiri", "Salon filtiri", "Transmissiya filtiri", "Əyləc mayesi"].includes(sc.name));
        }
        return subCats;
    }

    return (
        <Box className="profile-container">
            <Box className="add-product-header-row">
                <Typography className="add-product-title">Məhsul əlavə et</Typography>
                <FormControl className="add-product-header-dropdown">
                    <InputLabel>Tip</InputLabel>
                    <Select
                        value={productType}
                        label="Tip"
                        style={{ height: 37 }}
                        onChange={(e) => {
                            setProductType(e.target.value);
                            setFormData({
                                productName: "", category: "", subCategory: "", salePrice: "",
                                cost: "", quantity: "", fuelType: "", code: "", company: "",
                                literForOneBidon: "", color: ""
                            });
                            setShowRengInput(false);
                            setReng("");
                        }}
                    >
                        <MenuItem value="Digər məhsul">Digər məhsul</MenuItem>
                        <MenuItem value="Filter">Filter</MenuItem>
                        <MenuItem value="Yağlar">Yağlar</MenuItem>
                    </Select>
                </FormControl>
            </Box>

            <Divider className="add-product-divider" />

            {productType === "Yağlar" ? (

                <>
                    <Grid container spacing={2}>
                        <Grid item xs style={{ flex: 1 }}>
                            <FormControl fullWidth>
                                <InputLabel>Şirkət adı</InputLabel>
                                <Select
                                    label="Şirkət adı"
                                    value={formData.company || ""}
                                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                                    onOpen={refetch}
                                    MenuProps={{
                                        anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                        transformOrigin: { vertical: "top", horizontal: "left" },
                                        getContentAnchorEl: null,
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                                overflowY: "auto"
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem onClick={() => setOpenPopup(true)}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                            <span style={{ color: "#1976d2" }}>Yeni Şirkət</span>
                                            <Add style={{ marginRight: 5, color: "#1976d2" }} fontSize="small" />
                                        </Box>
                                    </MenuItem>
                                    {!isLoading && companiesArray.map((c, i) => (
                                        <MenuItem key={i} value={c.id}>
                                            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                                <span>{c.name}</span>
                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); setDeletePopup({ open: true, id: c.id, name: c.name }); }}>
                                                    <Delete fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs style={{ flex: 1 }}>
                            <FormControl fullWidth>
                                <InputLabel>Alt kateqoriya</InputLabel>
                                <Select
                                    label="Alt kateqoriya"
                                    value={formData.subCategory || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData({ ...formData, subCategory: value });
                                        const selectedSub = getSubCategories().find(sc => sc.id === value);
                                        if (selectedSub?.name === "Antifriz") setShowRengInput(true);
                                        else { setShowRengInput(false); setReng(""); }
                                    }}

                                >
                                    {getSubCategories().map((sc) => (
                                        <MenuItem key={sc.id} value={sc.id}>{sc.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ marginTop: 16 }}>
                        <Grid item xs style={{ flex: 1 }}>
                            <TextField fullWidth label="Məhsulun adı" value={formData.productName || ""} onChange={(e) => handleProductNameInput(e.target.value)} />
                        </Grid>
                        <Grid item xs style={{ flex: 1 }}>
                            <FormControl fullWidth>
                                <InputLabel>Yanacaq növləri</InputLabel>
                                <Select label="Yanacaq növləri" value={formData.fuelType || ""} onChange={(e) => setFormData({ ...formData, fuelType: e.target.value })}>
                                    {fuelTypes.map((ft, i) => <MenuItem key={i} value={ft}>{ft}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ marginTop: 16 }}>
                        <Grid item xs style={{ flex: 1 }}>
                            <TextField fullWidth label="Satış Qiymət" value={formData.salePrice || ""} onChange={(e) => handleDecimalNumberInput("salePrice", e.target.value)} />
                        </Grid>
                        {isOilSubSelected && (
                            <Grid item xs style={{ flex: 1 }}>
                                <TextField fullWidth label="Maya dəyəri" value={formData.cost || ""} onChange={(e) => handleDecimalNumberInput("cost", e.target.value)} />
                            </Grid>
                        )}
                    </Grid>

                    {isOilSubSelected && (
                        <Grid container spacing={2} style={{ marginTop: 16 }}>
                            <Grid item xs style={{ flex: 1 }}>
                                <TextField fullWidth label="Miqdar" value={formData.quantity || ""} onChange={(e) => handleNumberInput("quantity", e.target.value)} />
                            </Grid>
                            <Grid item xs style={{ flex: 1 }}>
                                <TextField fullWidth label="Litr" value={formData.literForOneBidon || ""} onChange={(e) => handleDecimalNumberInput("literForOneBidon", e.target.value)} />
                            </Grid>
                        </Grid>
                    )}

                    <Grid container spacing={2} style={{ marginTop: 16 }}>
                        <Grid item xs style={{ flex: 1 }}>
                            <TextField fullWidth label="Kod" value={formData.code || ""} onChange={(e) => handleCodeInput(e.target.value)} />
                        </Grid>
                        {showRengInput ? (
                            <Grid item xs style={{ flex: 1 }}><TextField fullWidth label="Rəng" value={reng} onChange={(e) => setReng(e.target.value)} /></Grid>
                        ) : <Grid item xs style={{ flex: 1 }} />}
                    </Grid>
                </>
            ) : (

                <>
                    <Grid container spacing={0}>
                        <Grid item xs style={{ flex: 1, paddingRight: 8 }}>
                            <TextField fullWidth label="Məhsulun adı" value={formData.productName || ""} onChange={(e) => handleProductNameInput(e.target.value)} />
                        </Grid>
                        <Grid item xs style={{ flex: 1, paddingLeft: 8 }}>
                            <FormControl fullWidth>
                                <InputLabel>Kategoriya</InputLabel>
                                <Select
                                    label="Kategoriya"
                                    value={productType === "Filter" ? "Avtomobil hissələri / ehtiyat hissələri" : formData.category || ""}
                                    onChange={(e) => setFormData({ ...formData, category: e.target.value, subCategory: "" })}
                                    disabled={productType === "Filter"}
                                >
                                    {categories.map((c) => <MenuItem key={c.id} value={c.category}>{c.category}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: 16 }}>
                        <Grid item xs style={{ flex: 1, paddingRight: 8 }}>
                            <TextField fullWidth label="Satış Qiymət" value={formData.salePrice || ""} onChange={(e) => handleDecimalNumberInput("salePrice", e.target.value)} />
                        </Grid>
                        <Grid item xs style={{ flex: 1, paddingLeft: 8 }}>
                            <FormControl fullWidth>
                                <InputLabel>Alt kateqoriya</InputLabel>
                                <Select
                                    label="Alt kateqoriya"
                                    value={formData.subCategory || ""}
                                    onChange={(e) => setFormData({ ...formData, subCategory: e.target.value })}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 250,
                                                width: 180,
                                            },
                                        },
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left",
                                        },
                                        transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left",
                                        },
                                    }}
                                >
                                    {getSubCategories().map((sc) => (
                                        <MenuItem key={sc.id} value={sc.id}>{sc.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: 16 }}>
                        <Grid item xs style={{ flex: 1, paddingRight: 8 }}>
                            <TextField fullWidth label="Maya dəyəri" value={formData.cost || ""} onChange={(e) => handleDecimalNumberInput("cost", e.target.value)} />
                        </Grid>
                        <Grid item xs style={{ flex: 1, paddingLeft: 8 }}>

                            {productType === "Filter" ? (
                                isBrakeFluidSelected ? (
                                    <TextField fullWidth label="Miqdar" value={formData.quantity || ""} onChange={(e) => handleNumberInput("quantity", e.target.value)} />
                                ) : (
                                    <TextField select fullWidth label="Yanacaq növləri" value={formData.fuelType || ""} onChange={(e) => setFormData({ ...formData, fuelType: e.target.value })}>
                                        {fuelTypes.map((ft, i) => <MenuItem key={i} value={ft}>{ft}</MenuItem>)}
                                    </TextField>
                                )
                            ) : (
                                <TextField fullWidth label="Miqdar" value={formData.quantity || ""} onChange={(e) => handleNumberInput("quantity", e.target.value)} />
                            )}
                        </Grid>
                    </Grid>

                    {productType === "Filter" && (
                        <Grid container spacing={2} style={{ marginTop: 16 }}>
                            {isBrakeFluidSelected ? (

                                <>
                                    <Grid item xs style={{ flex: 1 }}>
                                        <TextField fullWidth label="Litr" value={formData.literForOneBidon || ""} onChange={(e) => handleDecimalNumberInput("literForOneBidon", e.target.value)} />
                                    </Grid>
                                    <Grid item xs style={{ flex: 1 }} />
                                </>
                            ) : (

                                <>
                                    <Grid item xs style={{ flex: 1 }}>
                                        <TextField fullWidth label="Miqdar" value={formData.quantity || ""} onChange={(e) => handleNumberInput("quantity", e.target.value)} />
                                    </Grid>
                                    <Grid item xs style={{ flex: 1 }}>
                                        <TextField fullWidth label="Kod" value={formData.code || ""} onChange={(e) => handleCodeInput(e.target.value)} />
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    )}
                </>
            )}

            <Box style={{ marginTop: 24, display: "flex", justifyContent: "flex-end" }}>
                <Button variant="contained" color="primary" onClick={handleSubmit} disabled={!isFormValid()}>
                    Əlavə et
                </Button>
            </Box>


            <Dialog open={openPopup} onClose={() => setOpenPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Yeni Şirkət Əlavə Et</DialogTitle>
                <DialogContent>
                    <TextField
                        style={{ marginTop: "20px", marginBottom: "20px" }}
                        fullWidth autoFocus label="Şirkət adı" value={newCompany}
                        onChange={(e) => { if (/^[a-zA-Z0-9\s]*$/.test(e.target.value)) setNewCompany(e.target.value); }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenPopup(false)}>Ləğv et</Button>
                    <Button onClick={handleAddCompany} variant="contained">Təsdiqlə</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deletePopup.open} onClose={() => setDeletePopup({ open: false, id: null, name: "" })} maxWidth="xs" fullWidth>
                <DialogTitle>Şirkəti sil</DialogTitle>
                <DialogContent>
                    <Typography style={{ marginTop: "10px" }}>
                        <b>{deletePopup.name}</b> şirkətini silmək istədiyinizə əminsiniz?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeletePopup({ open: false, id: null, name: "" })}>Xeyr</Button>
                    <Button 
                        onClick={() => {
                            handleRemoveCompany(deletePopup.id);
                            setDeletePopup({ open: false, id: null, name: "" });
                        }} 
                        variant="contained" 
                        color="error"
                    >
                        Bəli, sil
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={toast.open} autoHideDuration={4000} onClose={() => setToast({ ...toast, open: false })} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={() => setToast({ ...toast, open: false })} severity={toast.severity} sx={{ width: '100%' }}>
                    {toast.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}